function createDropDowns() {
	$('dl').remove();
	$.each($('.product-form .field'), function (index, value) {
		var num = index + 1;
		$(this).attr('id', 'field-' + num);
		$('select', this).attr('id', 'select-' + num);
	});

	$.each($('.product-form .field'), function () {
		var source = $('select', this);
		var selectID = $(source).attr('id');
		var selected = source.find('option[selected]');

		var options = $('option', source).not(':selected');

		$(this).append('<dl id="' + selectID + '" class="dropdown"></dl>');
		$('#' + selectID + '.dropdown').append(
			'<dt><a href="#">' +
				selected.text() +
				'<span class="value">' +
				selected.val() +
				'</span></a></dt>'
		);
		$('#' + selectID + '.dropdown').append('<dd><ul></ul></dd>');
		options.each(function () {
			$('#' + selectID + ' dd ul').append(
				'<li><a href="#">' +
					$(this).text() +
					'<span class="value">' +
					$(this).val() +
					'</span></a></li>'
			);
		});
	});

	$('dl:first').addClass('selected');
	$('dl').not(':first').addClass('disabled');
}

function dropdown() {
	$('.dropdown dt a')
		.off()
		.on('click', function () {
			if ($(this).closest('.dropdown').hasClass('disabled')) {
				return false;
			} else {
				var dropdown = $(this).closest('.dropdown').attr('id');
				$('#' + dropdown + ' dd ul').show();
				return false;
			}
		});

	$('.dropdown dd ul li a')
		.off('click')
		.on('click', function () {
			var dropdown = $(this).closest('.dropdown').attr('id');
			$('#' + dropdown + '.dropdown dd ul li a').removeClass('selected');
			$(this).addClass('selected');
			$(this).closest('.dropdown').removeClass('next');
			$(this).closest('.dropdown').addClass('selected');
			var text = $(this).html();
			$('#' + dropdown + ' dt a').html(text);
			$('#' + dropdown + ' dd ul').hide();

			var value = $(this).find('span.value').html();

			if (value.indexOf('&amp;') > -1) {
				value = value.replace(/&amp;/g, '&');
			}

			var source = $('select#' + dropdown);
			source.val(value).change();
			return false;
		});

	$(document).bind('click', function (e) {
		var $clicked = $(e.target);
		if (!$clicked.parents().hasClass('dropdown')) {
			$('.dropdown dd ul').hide();
		}
	});
}

function productForm() {
	$('.disabled').click(function () {
		return false;
	});

	$('dd ul li a').on('click', function () {
		var fields = $('dl').length;
		var selected = $('dl.selected').length;
		if (selected >= 1) {
			$('.select-options').removeClass('disabled');
			$('.select-options').addClass('active');
		}
		if (selected == fields) {
			$('.select-options').addClass('confirm');
		}
	});

	$('.i').click(function () {
		$(this).siblings('.info-popup').toggle();
	});
}

function quantity() {
	$('.plus-minus.q .minus').click(function () {
		var quantityField = $(this)
			.closest('.product-result')
			.find('input[name*="qty"]');
		var backorder = $(this)
			.closest('.product-result')
			.find('span#inventory')
			.data('backorders');
		var count = parseInt($(quantityField).val());
		if (backorder) {
			if (count >= 1) {
				count--;
				$(quantityField).val(count).change();
			}
			if (count <= inventory) {
				$(this)
					.closest('.product-result')
					.find('.lead-time-alert')
					.hide();
			}
		} else {
			if (count >= 1) {
				count--;
				$(quantityField).val(count).change();
			} else {
				alert(
					'That is all of the product we have in stock at the moment.'
				);
			}
		}
	});

	$('.plus-minus.q .plus').click(function () {
		var quantityField = $(this)
			.closest('.product-result')
			.find('input[name*="qty"]');
		var backorder = $(this)
			.closest('.product-result')
			.find('span#inventory')
			.data('backorders');
		var inventory = parseInt(
			$(this)
				.closest('.product-result')
				.find('span#inventory')
				.data('inventory')
		);

		var count = parseInt($(quantityField).val());
		if (backorder) {
			if (count < inventory) {
				count++;
				$(quantityField).val(count).change();
			} else {
				count++;
				$(quantityField).val(count).change();
				$(this)
					.closest('.product-result')
					.find('.lead-time-alert')
					.show();
			}
		} else {
			if (count < inventory) {
				count++;
				$(quantityField).val(count).change();
			} else {
				alert(
					'That is all of the product we have in stock at the moment.'
				);
			}
		}
	});

	$('.product-result')
		.find("input[name*='qty']")
		.on('input', function () {
			var count = parseInt($(this).val()) || 0;
			var inventory =
				parseInt(
					$(this)
						.closest('.product-result')
						.find('span#inventory')
						.data('inventory')
				) || 0;
			var backorder = $(this)
				.closest('.product-result')
				.find('span#inventory')
				.data('backorders');
			if (backorder) {
				if (count <= inventory) {
					$(this)
						.closest('.product-result')
						.find('.lead-time-alert')
						.hide();
				} else {
					$(this)
						.closest('.product-result')
						.find('.lead-time-alert')
						.show();
				}
			} else {
				if (count > inventory) {
					alert(
						'That is all of the product we have in stock at the moment.'
					);
					$(this).val('1').change();
				}
			}
		});
}

function numberOfCuts() {
	$('.plus-minus.cuts .minus').click(function () {
		var numberOfCutsField = $(this)
			.parent()
			.find('input[name="number_of_cuts"]');
		var count = parseInt($(numberOfCutsField).val());
		if (count > 0) {
			count--;
			$(numberOfCutsField).val(count).change();
		}
		$.fn.matchHeight._update();
	});

	$('.plus-minus.cuts .plus').click(function () {
		var numberOfCutsField = $(this)
			.parent()
			.find('input[name="number_of_cuts"]');
		var count = parseInt($(numberOfCutsField).val());
		count++;
		$(numberOfCutsField).val(count).change();
		$.fn.matchHeight._update();
	});
}

function diQuantity() {
	$('.product-result')
		.find("input[name*='qty']")
		.on('input', function () {
			var count = parseInt($(this).val()) || 0;
			var inventory =
				parseInt(
					$(this)
						.closest('.product-result')
						.find('span#inventory')
						.data('inventory')
				) || 0;
			var backorder = $(this)
				.closest('.product-result')
				.find('span#inventory')
				.data('backorders');
			if (backorder) {
				if (count <= inventory) {
					$(this)
						.closest('.product-result')
						.find('.lead-time-alert')
						.hide();
				} else {
					$(this)
						.closest('.product-result')
						.find('.lead-time-alert')
						.show();
				}
			} else {
				if (count > inventory) {
					alert(
						'That is all of the product we have in stock at the moment.'
					);
					$(this).val('1').change();
				}
			}
		});
	$('.plus-minus.q .minus').click(function () {
		var quantityField = $(this)
			.closest('.product-result')
			.find('input[name*="qty"]');
		var inventory =
			parseInt(
				$(this)
					.closest('.product-result')
					.find('span#inventory')
					.data('inventory')
			) || 0;
		var count = parseInt($(quantityField).val()) || 0;
		var backorder = $(this)
			.closest('.product-result')
			.find('span#inventory')
			.data('backorders');
		if (backorder) {
			if (count >= 1) {
				count--;
				$(quantityField).val(count).change();
			}
			if (count <= inventory) {
				$(this)
					.closest('.product-result')
					.find('.lead-time-alert')
					.hide();
			}
		} else {
			if (count >= 1) {
				count--;
				$(quantityField).val(count).change();
			} else {
				alert(
					'That is all of the product we have in stock at the moment.'
				);
			}
		}
	});

	$('.plus-minus.q .plus').click(function () {
		var quantityField = $(this)
			.closest('.product-result')
			.find('input[name*="qty"]');
		var inventory =
			parseInt(
				$(this)
					.closest('.product-result')
					.find('span#inventory')
					.data('inventory')
			) || 0;
		var count = parseInt($(quantityField).val()) || 0;
		var backorder = $(this)
			.closest('.product-result')
			.find('span#inventory')
			.data('backorders');
		if (backorder) {
			if (count < inventory) {
				count++;
				$(quantityField).val(count).change();
			} else {
				count++;
				$(quantityField).val(count).change();
				$(this)
					.closest('.product-result')
					.find('.lead-time-alert')
					.show();
			}
		} else {
			if (count < inventory) {
				count++;
				$(quantityField).val(count).change();
			} else {
				alert(
					'That is all of the product we have in stock at the moment.'
				);
			}
		}
	});
}

function popupControls() {
	$('.close-button').click(function () {
		$('.cart-popup').fadeOut();
		$('.cart-popup popup-content').remove();
	});

	$('.continue-shopping').click(function () {
		$('.cart-popup').fadeOut();
		$('.cart-popup popup-content').remove();
	});
}

function formControls() {
	$('input[name="use_billing_info"]').on('change', function () {
		var currentForm = $(this).closest('form').attr('id');
		var billingInfo = $('#' + currentForm + ' fieldset:first .field input')
			.map(function () {
				return $(this).val();
			})
			.get();
		if ($(this).is(':checked')) {
			$.each(billingInfo, function (index, value) {
				$('#' + currentForm + ' fieldset:nth-of-type(2) .field input')
					.eq(index)
					.val(value)
					.trigger('change');
			});
		} else {
			$('#' + currentForm + ' fieldset:nth-of-type(2) .field input')
				.val('')
				.trigger('change');
		}
	});
}

function viewOrders() {
	$('.account-section .view-all').on('click', function () {
		if ($(this).hasClass('show')) {
			$(this).text('Click to View All');
			$(this).removeClass('show');
			$('.account-section li.show')
				.removeClass('show')
				.addClass('hidden');
		} else {
			$(this).text('Click to Hide');
			$(this).addClass('show');
			$('.account-section li.hidden')
				.removeClass('hidden')
				.addClass('show');
		}
	});
}

function matchHeight() {
	var sidebarHeight = $('#sidebar').outerHeight();

	$('.content-wrap').css('min-height', sidebarHeight);
}

function qtyUpdated($this, index) {
	if ($this.val() == 0) {
		$('#remove-' + index).prop('checked', true);
	} else {
		$('#remove-' + index).prop('checked', false);
	}
}

var kerf = 0.125;

$(document).on('change', '.cuts-number', function () {
	var cutsField;
	var bodyId = $('body').attr('id');
	var cutsArray = [];
	var cuts = $(this).val();
	var wrap = $(this).parents('.info-row');
	var container = $(wrap).find('.cuts-fields');
	var cutBlock = wrap.find('.definable-cuts');
	var lnId = cutBlock.parents('.info-row').data('line-item');
	var row = cutBlock.data('row');
	container.find('.cut-field').each(function () {
		cutsArray.push($(this).val());
	});
	container.empty();

	if (bodyId == 'cart') {
		var cutsField = 'lineItems[' + lnId + '][options][definedCuts][]';
	} else {
		var cutsField = 'purchasables[' + row + '][options][definedCuts][]';
	}
	for (i = 0; i < cuts; i++) {
		if (cutsArray[i]) {
			if (row > -1) {
				var cutField =
					'<div class="field-wrap"><label>Cut ' +
					(i + 1) +
					'</label><input type="number" step="any" name="' +
					cutsField +
					'" value ="' +
					cutsArray[i] +
					'" type="text" class="cut-field" placeholder="Cut length in inches" name="cut-' +
					(i + 1) +
					'" id="cut-' +
					(i + 1) +
					'" required></div>';
			} else {
				var cutField =
					'<div class="field-wrap"><label>Cut ' +
					(i + 1) +
					'</label><input type="number" step="any" name="options[definedCuts][]" value ="' +
					cutsArray[i] +
					'" type="text" class="cut-field" placeholder="Cut length in inches" name="cut-' +
					(i + 1) +
					'" id="cut-' +
					(i + 1) +
					'" required></div> ';
			}
		} else {
			if (row > -1) {
				var cutField =
					'<div class="field-wrap"><label>Cut ' +
					(i + 1) +
					'</label><input type="number" step="any" name="' +
					cutsField +
					'" class="cut-field" placeholder="Cut length in inches" name="cut-' +
					(i + 1) +
					'" id="cut-' +
					(i + 1) +
					'" required></div> ';
			} else {
				var cutField =
					'<div class="field-wrap"><label>Cut ' +
					(i + 1) +
					'</label><input type="number" step="any" name="options[definedCuts][]" class="cut-field" placeholder="Cut length in inches" name="cut-' +
					(i + 1) +
					'" id="cut-' +
					(i + 1) +
					'" required></div> ';
			}
		}
		container.append(cutField);
	}

	if (cuts != 0) {
		container.append(
			'<div class="field-wrap"><label>Drop</label><input type="text" placeholder="Remainder" id="drop" name="drop" readonly></div>'
		);
	}

	if (cuts == 1) {
		container.append(
			'<div class="field-wrap"><button type="button" class="halve-item">Cut in Half</button></div>'
		);
	}

	if (cuts == 0) {
		container.append(
			'<input type="hidden" id="cut-reset" name="lineItems[' +
				lnId +
				'][options][definedCuts][]" value="0">'
		);
	}

	updateCuts(null, wrap);
});

$(document).on('change', '.cut-field', function () {
	var wrap = $(this).parents('.info-row');
	updateCuts($(this), wrap);
});

$(document).on(
	'change',
	'.cut-field, .cuts-number, input[name*="quantity"]',
	function () {
		watchChanges(this);
	}
);

$(document).on(
	'input',
	'.cut-field, .cuts-number, input[name*="quantity"]',
	function () {
		watchChanges(this);
	}
);

function watchChanges(el) {
	var $el = $(el);
	var currentValue = parseFloat($el.val());
	var previousValue = parseFloat($el.data('value'));
	var $input = $el.parents('.product-result').find('input.update');
	if (currentValue !== previousValue) {
		$input.attr('data-changed', 'true');
	} else {
		$input.attr('data-changed', 'false');
	}
}

function halveItem(wrap) {
	var totalLength = $(wrap).find('.cuts-line').attr('data-length');
	$(wrap)
		.find('#cut-1')
		.val(totalLength / 2);
	$(wrap)
		.find('#drop')
		.val(totalLength / 2);
	updateCuts(null, wrap);
}

$(document).on('click', '.halve-item', function () {
	var wrap = $(this).parents('.info-row');
	halveItem(wrap);
});

function updateCuts(el, wrap) {
	var cutsArray = [];
	var cuts = [];
	var sum = 0;
	var totalLength = $(wrap).find('.cuts-line').attr('data-length');
	var drop = totalLength;
	$(wrap)
		.find('.cut-field')
		.each(function (i, e) {
			cutsArray.push(e.value);
		});

	for (var i = 0; i < cutsArray.length; i++) {
		if (cutsArray[i] == '') {
			var cut = 0;
		} else {
			var cut = cutsArray[i];
		}
		if (cut > 0) {
			var cutWithKerf = parseFloat(cut) + kerf;
			sum += cutWithKerf;
			if (totalLength - sum < 0) {
				cutsArray.splice(i, 1);
				el.val('');
			} else {
				drop = totalLength - sum;
				drop = Math.round((drop + Number.EPSILON) * 1000) / 1000;
			}
		}
	}

	if (drop >= 0) {
		$(wrap).find('.cut-marker').remove();
		cutsArray.forEach(function (item, index) {
			var cutPercent = (item / totalLength) * 100;
			if (item != '') {
				var cutMarker =
					'<div class="cut-marker set-marker" data-cut="' +
					item +
					'" style="width: ' +
					cutPercent +
					'%"><div class="cut-value">' +
					item +
					'"</div></div>';
				cuts.push(cutMarker);
			}
		});

		$(wrap).find('.cuts-line').prepend(cuts);
		$(wrap)
			.find('.cuts-line')
			.append(
				'<div class="cut-marker remainder"><div class="cut-value">' +
					drop +
					'"</div></div-->'
			);
		$(wrap).find('#drop').val(drop);
	}
}

$(function () {
	if ($('body').attr('id') == 'cart') {
		var cutBlock = $('.definable-cuts');

		cutBlock.each(function () {
			var row;
			var cuts = [];
			var $cutsLine = $(this).find('.cuts-line');
			var lnId = $(this).parents('.info-row').data('line-item');
			cuts = $(this).data('defined-cuts');
			row = $(this).data('row');
			var totalLength = $cutsLine.data('length');
			$cutsLine.empty();

			if (!cuts) {
				return;
			}

			var sum = 0;
			for (var i = 0; i < cuts.length; i++) {
				if (cuts[i] == '') {
					var cut = 0;
				} else {
					var cut = cuts[i];
				}
				var cutWithKerf = parseFloat(cut) + kerf;
				sum += cutWithKerf;
			}

			var drop = totalLength - sum;
			drop = Math.round((drop + Number.EPSILON) * 1000) / 1000;
			cuts.forEach(function (item) {
				var cutPercent = (item / totalLength) * 100;
				var cutMarker =
					'<div class="cut-marker set-marker" data-cut="' +
					item +
					'" style="width: ' +
					cutPercent +
					'%"><div class="cut-value">' +
					item +
					'"</div></div>';
				$cutsLine.append(cutMarker);
			});
			$cutsLine.append(
				'<div class="cut-marker remainder"><div class="cut-value">' +
					drop +
					'"</div></div>'
			);

			var container = $(this).siblings('.cuts-fields');
			for (i = 0; i < cuts.length; i++) {
				if (cuts[i]) {
					if (row > -1) {
						var cutField =
							'<div class="field-wrap"><label>Cut ' +
							(i + 1) +
							'</label><input name="lineItems[' +
							lnId +
							'][options][definedCuts][]" value ="' +
							cuts[i] +
							'" type="text" class="cut-field" placeholder="Cut length in inches" name="cut-' +
							(i + 1) +
							'" id="cut-' +
							(i + 1) +
							'" required data-value="' +
							cuts[i] +
							'"></div> ';
					}
				} else {
					var cutField =
						'<div class="field-wrap"><label>Cut ' +
						(i + 1) +
						'</label><input name="options[definedCuts][]" class="cut-field" placeholder="Cut length in inches" name="cut-' +
						(i + 1) +
						'" id="cut-' +
						(i + 1) +
						'" required></div> ';
				}
				container.append(cutField);
			}

			if (cuts.length != 0) {
				container.append(
					'<div class="field-wrap"><label>Drop</label><input type="text" placeholder="Remainder" id="drop" name="drop" value="' +
						drop +
						'"readonly></div> '
				);
			}

			if (cuts.length == 1) {
				container.append(
					'<div class="field-wrap"><button type="button" class="halve-item">Cut in Half</button></div>'
				);
			}
		});
	}
});

$('#estimate-reset').click(function (e) {
	e.preventDefault();
	$('#ship-check-results').remove();
	$('#shipping-disclaimer').remove();
	$('#shipping_zip').prop('disabled', false);
	$('#ship-check-submit').show();
	$('#estimate-reset').hide();
});

$('#quick-ship').submit(function (e) {
	e.preventDefault();
	var data = $('#quick-ship').serialize();
	$.ajax({
		url: '',
		type: 'post',
		data: data,
		dataType: 'json',
		beforeSend: function (response) {
			$('#ship-check-submit').hide();
			$('#shipping_zip').prop('disabled', true);
			$('#quick-ship').append(
				'<div id="spinner"><i class="fas fa-cog"></i></div>'
			);
		},
		success: function (response) {
			var shippingOptions = response.cart.availableShippingMethodOptions;
			var lineItems = response.cart.lineItems;
			var optionsList = [];
			var surcharges = [];
			var packageCharges = 0;
			var formatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
			});

			lineItems.forEach(function (item) {
				if (item.options.surcharge) {
					if (item.options.shippingType == 'PACKAGE') {
						packageCharges = true;
					} else {
						surcharges.push(item.options.surcharge);
					}
				} else if (
					item.options.shippingType == 'PACKAGE' &&
					item.length > 48 &&
					!('definedCuts' in item.options)
				) {
					packageCharges = true;
				} else {
					surcharges.push(0);
				}
			});
			var appliedSurcharge = Math.max(...surcharges);
			for (item in shippingOptions) {
				var surcharge = 0;
				if (
					shippingOptions[item].name == 'LTL Freight' &&
					appliedSurcharge > 15
				) {
					surcharge = appliedSurcharge;
				} else if (
					shippingOptions[item].handle != '349' &&
					shippingOptions[item].handle != 'will_call_west' &&
					shippingOptions[item].handle != 'will_call_telephone' &&
					shippingOptions[item].handle != 'customer_account' &&
					shippingOptions[item].handle != 'OUR_TRUCK' &&
					shippingOptions[item].handle != 'requestAShippingQuote' &&
					packageCharges == true
				) {
					var weight = response.cart.totalWeight;
					var numberOfPackages = Math.ceil(weight / 50);
					var packageChargeAmount = numberOfPackages * 12;
					surcharge = packageChargeAmount;
				}
				optionsList.push(
					'<li><p>' +
						shippingOptions[item].name +
						': ' +
						'<b>' +
						formatter.format(
							shippingOptions[item].price + surcharge
						) +
						'</b></p>'
				);
			}
			console.log(response);
			if (response.cart.availableShippingMethodOptions['OUR_TRUCK']) {
				var rateDetails =
					'<p><strong>' + response.cart.message + '</p></strong>';
			} else {
				rateDetails = '';
			}

			document.getElementById('spinner').remove();
			console.log(349 in shippingOptions);
			$('#quick-ship').append(
				'<div id="ship-check-results" class="totals">' +
					'<h4>Estimated Shipping Cost</h4>' +
					'<ul>' +
					optionsList.join('') +
					'</ul>' +
					rateDetails +
					'</div>' +
					'<div id="shipping-disclaimer">' +
					'<p>Estimated shipping costs may differ from final cost applied during checkout.  You will see final shipping cost before completing your order.</p>' +
					'</div>'
			);

			$('#estimate-reset').show();
		},
		error: function (response) {
			console.error(response);
		},
		complete: function () {
			var sidebarEls = $('#sidebar').children();
			var totalHeight = 0;

			sidebarEls.each(function () {
				totalHeight += $(this).outerHeight();
			});

			$('#sidebar').css('height', totalHeight + 150);
		},
	});
});

var states = {
	AL: 'AL',
	AK: 'AK',
	AZ: 'AZ',
	AR: 'AR',
	CA: 'CA',
	CO: 'CO',
	CT: 'CT',
	DE: 'DE',
	DC: 'DC',
	FL: 'FL',
	GA: 'GA',
	HI: 'HI',
	ID: 'ID',
	IL: 'IL',
	IN: 'IN',
	IA: 'IA',
	KS: 'KS',
	KY: 'KY',
	LA: 'LA',
	ME: 'ME',
	MD: 'MD',
	MA: 'MA',
	MI: 'MI',
	MN: 'MN',
	MS: 'MS',
	MO: 'MO',
	MT: 'MT',
	NE: 'NE',
	NV: 'NV',
	NH: 'NH',
	NJ: 'NJ',
	NM: 'NM',
	NY: 'NY',
	NC: 'NC',
	ND: 'ND',
	OH: 'OH',
	OK: 'OK',
	OR: 'OR',
	PA: 'PA',
	RI: 'RI',
	SC: 'SC',
	SD: 'SD',
	TN: 'TN',
	TX: 'TX',
	UT: 'UT',
	VT: 'VT',
	VA: 'VA',
	WA: 'WA',
	WV: 'WV',
	WI: 'WI',
	WY: 'WY',
};
Parsley.addValidator('zip', {
	validateString: function (value, country) {
		return true;
	},
	messages: { en: 'There is no such zip for the country "%s"' },
});
Parsley.addValidator('stateAndZip', {
	validateString: function (_ignoreValue, country, instance) {
		console.log(instance);
		var stateId = instance.$element.find('.state-select').val();
		var state = states[stateId];
		var zip = instance.$element.find('.zip-value').val();
		console.log(state, zip);

		return true;
	},
	messages: { en: 'There is no such zip for the country "%s"' },
});

$(function () {
	$('#address-update').parsley({
		inputs: Parsley.options.inputs + ',fieldset',
	});
});
